import 'keen-slider/keen-slider.min.css';
import KeenSlider from 'keen-slider';

export const LogoBar = (() => {
    'use strict';

    function init() {
        const carousels = document.querySelectorAll('.pxblock--logo-bar');

        carousels.forEach((carousel) => {
            const sliderEl = carousel.querySelector('.keen-slider');

            const slider = new KeenSlider(sliderEl, {
                slides: {
                    perView: 3,
                    spacing: 30,
                    origin: 'center',
                },
                breakpoints: {
                    '(min-width: 1024px)': {
                        slides: {
                            perView: 7,
                            spacing: 70,
                        },
                    },
                },
                created: () => {},
                slideChanged: ({ track }) => {},
                loop: true,
            });

            carousel.querySelector('.prev')?.addEventListener('click', () => slider.prev());
            carousel.querySelector('.next')?.addEventListener('click', () => slider.next());
        });
    }

    return {
        init: init,
    };
})();
